<div class="grid sm:grid-cols-2 gap-4 items-center justify-between">
  <div class="flex gap-3">
    <!-- WhatsApp -->
    <a
      [href]="shareWhatsapp()"
      target="_blank"
      data-action="share/whatsapp/share"
    >
      <svg-icon class="hover:fill-secondary" src="/assets/icons/whatsapp.svg" />
      <span class="sr-only" i18n>WhatsApp</span>
    </a>

    <!-- Facebook -->
    <a [href]="shareFacebook()" target="_blank">
      <svg-icon class="hover:fill-secondary" src="/assets/icons/facebook.svg" />
      <span class="sr-only" i18n>Facebook</span>
    </a>

    <!-- X -->
    <a [href]="shareX()" target="_blank">
      <svg-icon class="hover:fill-secondary" src="/assets/icons/x.svg" />
      <span class="sr-only" i18n>X</span>
    </a>

    <!-- Email -->
    <a [href]="shareEmail()" target="_blank">
      <svg-icon class="hover:fill-secondary" src="/assets/icons/email.svg" />
      <span class="sr-only" i18n>Email</span>
    </a>

    <!-- Copy link -->
    <button
      (click)="copyLink()"
      target="_blank"
      #tooltip="matTooltip"
      [matTooltip]="copyLinkText()"
    >
      <svg-icon class="hover:fill-secondary" src="/assets/icons/link.svg" />
      <span class="sr-only" i18n>Copy link</span>
    </button>
  </div>
</div>
